import { render, staticRenderFns } from "./ModalCatalogFilter.vue?vue&type=template&id=8a89167a"
import script from "./ModalCatalogFilter.vue?vue&type=script&lang=js"
export * from "./ModalCatalogFilter.vue?vue&type=script&lang=js"
import style0 from "./ModalCatalogFilter.vue?vue&type=style&index=0&id=8a89167a&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports